module.exports = "ok";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/chunks/file.js
 ** module id = 1
 ** module chunks = 1
 **/